<template>
  <el-scrollbar style="width: 100%; overflow-x: hidden;">
    <div class="page">
      <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-bottom: 0;">
        <span>新增约量</span>
      </div>
      <div class="shadow-box">
        <div class="page-main_box placeholder-box">
          <div class="placeholder-text">新增约量页面开发中，后续完善</div>
          <el-button @click="goBack">返回</el-button>
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'SupChannelReserveManageAdd',
  methods: {
    goBack() {
      this.$router.push('/xpk/sup/channel-reserve-manage')
    }
  }
}
</script>

<style scoped>
.placeholder-box {
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
}

.placeholder-text {
  margin-bottom: 24px;
  font-size: 14px;
  color: #999;
}
</style>
